import { isIn } from '../../helpers/Helper';
import { CustomButton } from 'components/shared/CustomButton'
import { CustomDropdown } from 'components/shared/CustomDropdown';
import { CustomTextBox } from 'components/shared/CustomTextBox';
import React, { useState } from 'react'
import { Col, Modal, ModalBody, Row } from 'reactstrap'
import AddressFormIN from './AddressForm/AddressFormIN';
import AddressFormAE from './AddressForm/AddressFormAE';
import { IAddressModel } from 'models/Address.Model';


type AddressFormProps = {
    setIsAdd: any,
    personAddressInfo: Array<IAddressModel>,
    isEdit: boolean,
    pageFrom?: "ScheduleAddress" | "other",
    setDefaultShow?: any,
    setChangesInAddress?: any,
    isAdd: boolean,
    defaultValues?: IAddressModel,
    publicUserUniques: { Id: number, UserName: string, UserMobile: any },
    personId: any
}

export default function NewAddressForm({ personAddressInfo, isEdit, isAdd, setIsAdd, defaultValues, publicUserUniques, personId }: AddressFormProps) {

    return (
        <React.Fragment>
            <Row>
                {/* <Col lg="12" xs="12">
                    <CustomButton onClick={() => setIsAdd(true)} color="warning" type={'button'} btnClassName={'btn-success my-1'} iconClasssName={undefined} name={'Add Address'} />
                </Col> */}
                <Modal isOpen={isAdd} toggle={() => setIsAdd(false)} centered backdrop animated={true} swipeToClose={true} onDidDismiss={() => setIsAdd(false)} size='lg'>
                    <ModalBody>
                        <Row className='mb-1'>
                            <Col xl={10} lg={10} md={10} sm={10} xs={10} >
                                <div className=''>
                                    <i className='fas fa-address-book text-dofy me-2 font-size-14 '></i>
                                    <span className='font-size-14 fw-semibold text-dofy'>Add New Address</span>
                                </div>
                            </Col>
                            <Col className='text-end' xl={2} lg={2} md={2} sm={2} xs={2}>
                                <i className='bx bx-x font-size-18 cursor-pointer' onClick={() => setIsAdd(false)}></i>
                            </Col>
                        </Row>
                        {isIn() ? <AddressFormIN setIsAdd={setIsAdd} personDetailInfo={personAddressInfo} isEdit={isEdit} defaultValues={defaultValues} publicUserUniques={publicUserUniques} personId={personId} /> : <AddressFormAE setIsAdd={setIsAdd} personDetailInfo={personAddressInfo} isEdit={isEdit} defaultValues={defaultValues} publicUserUniques={publicUserUniques} personId={personId} />}
                    </ModalBody>
                </Modal>
            </Row>
        </React.Fragment>
    )
}
